export enum TabsType {
    PendingReferrals,
    MyReferrals,
    AllReferrals,
    Archived
  }
  
  export enum WCCTabsType {
    PendingAdmissions,
    MyAdmissions,
    AllAdmissions,
    PathwaysLibrary,
    Archived
  }